/* eslint-disable no-param-reassign */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export function dotPop(obj, time = 320, wait = 0, override = true) {
  if (!obj.scene) return;

  if (override) obj.scene.tweens.killTweensOf(obj);

  return ABCyaPhaser.Tweens.addTween(obj, 240, { scale: 1.6, alpha: 1, delay: wait }, Phaser.Math.Easing.Quadratic.In, () => {
    if (obj.scene) ABCyaPhaser.Tweens.addTween(obj, time, { scale: 1 }, Phaser.Math.Easing.Quadratic.Out);
  });
}

export function replaceSpaces (value, char) {
  return value.replace(/ /g, char);
}

export function resizeDimensions (currentWidth, currentHeight, maxWidth, maxHeight) {
  let scale = 1;
  if (currentWidth > maxWidth || currentHeight > maxHeight) {
    scale = Math.min(maxWidth / currentWidth, maxHeight / currentHeight);
  }
  return { width: currentWidth * scale, height: currentHeight * scale, scale };
}

export function trimCanvas(c) {
  const ctx = c.getContext('2d');
  const copy = document.createElement('canvas').getContext('2d');
  const pixels = ctx.getImageData(0, 0, c.width, c.height);
  const l = pixels.data.length;
  let i;
  const bound = {
    top: null,
    left: null,
    right: null,
    bottom: null
  };
  let x; let y;

  for (i = 0; i < l; i += 4) {
    if (pixels.data[i + 3] !== 0) {
      x = (i / 4) % c.width;
      y = ~~((i / 4) / c.width);

      if (bound.top === null) {
        bound.top = y;
      }

      if (bound.left === null) {
        bound.left = x;
      }
      else if (x < bound.left) {
        bound.left = x;
      }

      if (bound.right === null) {
        bound.right = x;
      }
      else if (bound.right < x) {
        bound.right = x;
      }

      if (bound.bottom === null) {
        bound.bottom = y;
      }
      else if (bound.bottom < y) {
        bound.bottom = y;
      }
    }
  }

  const trimHeight = bound.bottom - bound.top;
  const trimWidth = bound.right - bound.left;
  const trimmed = ctx.getImageData(bound.left, bound.top, trimWidth, trimHeight);

  copy.canvas.width = trimWidth;
  copy.canvas.height = trimHeight;
  copy.putImageData(trimmed, 0, 0);

  return copy.canvas;
}

/*
 * SR 5/30/2023 Bug with Phaser 3.55.2 `RenderTexture.snapshot` function
 * 
 * The following functions (snapshot and snapshotFramebuffer) are copied from Phaser's base code. They are slightly modified
 * to fix a bug with taking a snapshot of a RenderTexture that is larger than the screen.
 * 
 * Links to the original code:
 * snapshot: https://github.com/photonstorm/phaser/blob/v3.54.0/src/gameobjects/rendertexture/RenderTexture.js#L1321
 * snapshotFramebuffer: https://github.com/photonstorm/phaser/blob/4fea76252b28a21fc3ca2bed1d48588c4ef5a3d7/src/renderer/webgl/WebGLRenderer.js#L2671
 * 
 * This bug might be fixed in Phaser 3.60.0.
 */

// must bind this function call to a render texture; note: this removes the canvas version, the game MUST be running in WebGL
export function snapshot (callback, type, encoderOptions) {
  snapshotFramebuffer.apply(this.renderer, [this.renderTarget.framebuffer, this.width, this.height, callback, false, 0, 0, this.width, this.height, type, encoderOptions]);

  return this;
}

// must bind this function call to a WebGLRenderer
function snapshotFramebuffer (framebuffer, bufferWidth, bufferHeight, callback, getPixel, x, y, width, height, type, encoderOptions) {
  if (getPixel === undefined) { getPixel = false; }
  if (x === undefined) { x = 0; }
  if (y === undefined) { y = 0; }
  if (width === undefined) { width = bufferWidth; }
  if (height === undefined) { height = bufferHeight; }

  const currentFramebuffer = this.currentFramebuffer;

  this.snapshotArea(x, y, width, height, callback, type, encoderOptions);

  const state = this.snapshotState;

  // the bug is that it caps the snapshot to the size of the game screen for some reason (the capping happens in `this.snapshotArea`)... 
  // this "resets" the width/height back to what they should be
  state.width = width;
  state.height = height;

  state.getPixel = getPixel;

  state.isFramebuffer = true;
  state.bufferWidth = bufferWidth;
  state.bufferHeight = bufferHeight;

  this.setFramebuffer(framebuffer);

  // eslint-disable-next-line new-cap
  Phaser.Renderer.Snapshot.WebGL(this.canvas, state);

  this.setFramebuffer(currentFramebuffer);

  state.callback = null;
  state.isFramebuffer = false;

  return this;
}